import gsap from "gsap";
let geoMap = document.querySelector(".geographic-data-map");
let statesList = geoMap.querySelector(
	".geographic-data-map__map--state-list ul"
);
let svgStates = geoMap.querySelectorAll("#states > *");
let wordStates, statesData; // initialize these for later use
let statsBody = document.querySelector(
	".geographic-data-map__stats .stats-body"
);
let downloadLinkContainer = document.querySelector(".state-pdf-download");
let selectedState = "US"; // Default to selecting US first

function scrollToStats() {
	document
		.querySelector(".geographic-data-map__stats")
		.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
}

function selectAllStates() {
	svgStates.forEach((el) => {
		el.classList.add("selected");
	});
	document.querySelector("[data-state='US']").classList.add("selected");
}

function removeAllHovering() {
	document.querySelector(".svg-states title").innerHTML = "Map of U.S. States";
	wordStates.forEach(function (el) {
		el.classList.remove("hovering");
	});
	svgStates.forEach(function (el) {
		el.classList.remove("hovering");
	});
}

function removeAllSelected() {
	wordStates.forEach(function (el) {
		el.classList.remove("selected");
	});
	svgStates.forEach(function (el) {
		el.classList.remove("selected");
	});
}

function addHoveringFromList(el) {
	let stateCode = el.getAttribute("data-state");
	if (stateCode == "US") {
		svgStates.forEach((svg) => {
			svg.classList.add("hovering");
		});
		el.classList.add("hovering");
	} else {
		let svgState = document.querySelector("#" + stateCode);
		el.classList.add("hovering");
		svgState.classList.add("hovering");
	}
}

function addSelectedFromList(el) {
	let stateCode = el.getAttribute("data-state");
	if (stateCode == "US") {
		svgStates.forEach((svg) => {
			svg.classList.add("selected");
		});
		el.classList.add("selected");
	} else {
		let svgState = document.querySelector("#" + stateCode);
		el.classList.add("selected");
		svgState.classList.add("selected");
	}
}

function addHoveringFromState(el) {
	let stateId = el.getAttribute("id");
	let wordState = document.querySelector("[data-state='" + stateId + "']");
	document.querySelector(".svg-states title").innerHTML =
		el.getAttribute("data-name");
	el.classList.add("hovering");
	wordState.classList.add("hovering");
}

function addSelectedFromState(el) {
	let stateId = el.getAttribute("id");
	let wordState = document.querySelector("[data-state='" + stateId + "']");
	let wordPos = wordState.offsetLeft;
	el.classList.add("selected");
	wordState.classList.add("selected");
	statesList.scrollLeft = wordPos - 40;
}

function addMapListeners() {
	wordStates.forEach(function (el) {
		el.addEventListener("mouseenter", function () {
			removeAllHovering();
			selectedState == "US" && removeAllSelected();
			addHoveringFromList(el);
		});
		el.addEventListener("mouseleave", function () {
			removeAllHovering();
			selectedState == "US" && selectAllStates();
		});
		el.addEventListener("touchstart", function () {
			removeAllHovering();
			addHoveringFromList(el);
		});
		el.addEventListener("click", function () {
			removeAllHovering();
			removeAllSelected();
			addSelectedFromList(el);
			let stateCode = el.getAttribute("data-state");
			selectedState = stateCode;
			scrollToStats();
			updateSelectedState(statesData, stateCode);
		});
	});

	svgStates.forEach(function (el) {
		el.addEventListener("mouseenter", function () {
			removeAllHovering();
			selectedState == "US" && removeAllSelected();
			addHoveringFromState(el);
		});
		el.addEventListener("mouseleave", function () {
			removeAllHovering();
			selectedState == "US" && selectAllStates();
		});
		el.addEventListener("touchstart", function () {
			removeAllHovering();
			addHoveringFromState(el);
		});
		el.addEventListener("click", function () {
			removeAllHovering();
			removeAllSelected();
			addSelectedFromState(el);
			let stateCode = el.getAttribute("id");
			selectedState = stateCode;
			scrollToStats();
			updateSelectedState(statesData, stateCode);
		});
	});
}

function populateStatesList(states) {
	states.forEach((state) => {
    // console.log(state);
		setStateLi(state);
	});
	// Update our wordStates object for the SVG/li highlighting functions
	wordStates = geoMap.querySelectorAll(".list-of-states li");
}

function setStateLi(state) {
	let template = document.querySelector("#state-li");
	let clone = template.content.cloneNode(true);
	let li = clone.querySelector("li");
	li.dataset.state = state.abbreviation;
	li.innerText = state.name;
	state.abbreviation == "US" ? (li.style.order = "-1") : ""; // Make sure US is always at the front of the line
	statesList.appendChild(clone);
}

function setStateStats(stats) {
	let template = document.querySelector("#state-stat");
	statsBody.innerHTML = ""; // reset contents of stats-body

	for (let stat in stats) {
		// console.log(stat, stats);
		let clone = template.content.cloneNode(true);
		let statDiv = clone.querySelector(".stat");

		let statNumber = statDiv.querySelector(".stat-number");
		let statTitle = statDiv.querySelector(".stat-title");
		let statSubTitle = statDiv.querySelector(".stat-subtitle");
		let statSmallText = statDiv.querySelector(".stat-small-text");

		let re = /([^(\$)])(.*)([^a-zA-Z])/gi;

		statTitle.innerText = stat; // Set the title for the stat

		// I know this statement is really wild but it works, so... 👀
		// TO-DO Possibly make this not so intense looking lol
		// Anyways, if you're wondering what's actually going on here: First we check if our statNumber matches a regex pattern containing a dollar symbol. If it does, then that means it contains a dollar sign and ends with a alphabetical character (e.g $1B). We can only animate the number itself, not the other characters, so this helps us isolate that number and wrap it in a span. Of course, if we're only getting a number in the first place this regex won't match. If it doesn't match then we still want to wrap it in that span so we can have the same way to target them with the gsap function below.
		statNumber.innerHTML = stats[stat].number.match(/\D/g)
			? stats[stat].number.replace(
					re,
					"<span class='number'>" +
						stats[stat].number.match(new RegExp(re)) +
						"</span>"
			  )
			: stats[stat].number.replace(
					stats[stat].number,
					"<span class='number'>" +
						stats[stat].number.replace(/\D/g, "") +
						"</span>"
			  );

		// Phew, now just toss the subtitle and small text in their respective divs, if they exist.
		statSubTitle.innerHTML = stats[stat].subtitle ? stats[stat].subtitle : "";
		statSmallText.innerHTML = stats[stat].small_text
			? stats[stat].small_text
			: "";

		// Finally, after piecing it all together, actually attach the newly created stat div to the stats-body.
		statsBody.appendChild(clone);

		// And here is the animation function itself, which actually runs after the stat has already been set
		// this first one animates the numbers
		gsap.from(statNumber.querySelector(".number"), {
			textContent: 0,
			duration: 2,
			ease: "power1.in",
			// snap: { textContent: 1 },
			stagger: {
				each: 1.0,
				onUpdate: function () {
					const target = this.targets()[0];
					// We're setting this with the mostly unfiltered version of the content
					// so we can snap to it at the end
					target.setAttribute(
						"data-full-value",
						numberWithCommas(this.targets()[0].textContent)
					);
					target.innerHTML = numberWithCommas(
						Number(this.targets()[0].textContent).toFixed(0)
					);
				},
				onComplete: function () {
					const target = this.targets()[0];
					const fullValue = target.getAttribute("data-full-value");
					const textContentValue = target.textContent;
					if (fullValue !== textContentValue) {
						target.innerHTML = fullValue;
					}
				},
			},
		});

		// and this one animates the text under the numbers
		let anim = gsap.timeline();
		anim
			.from(statTitle, { duration: 1.0, opacity: 0 })
			.from(statSubTitle, { duration: 1.0, opacity: 0 })
			.from(statSmallText, {
				duration: 1.0,
				opacity: 0,
				stagger: { each: 0.25 },
			});
	}
}

function updateStateDownload(name, link) {
	downloadLinkContainer.querySelector("a").setAttribute("href", link);
	downloadLinkContainer.querySelector(".state-name").innerText = name;
	downloadLinkContainer.classList.remove("hidden");
}

function updateSelectedState(data, state) {
	let selectedStateData = data.find(
		({ abbreviation }) => abbreviation === state
	);
	document.querySelector("span.state-name").innerText = selectedStateData.name;
	setStateStats(selectedStateData.data);
	if (selectedStateData["copy"]) {
		// This HTML is escaped on the PHP side, so should be safe
		geoMap.querySelector(".description-body").innerHTML =
			selectedStateData["copy"];
	}
	// console.log("selected state data:", selectedStateData);
	selectedStateData.download
		? updateStateDownload(selectedStateData.name, selectedStateData.download)
		: downloadLinkContainer.classList.add("hidden");
}

function numberWithCommas(x) {
	// console.log(x);
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// When this script loads, fetch the JSON file we'll use to populate the state data.
fetch(geoMap.getAttribute("data-api-url"))
	.then((response) => response.json())
	.then((data) => {
		statesData = data;
		populateStatesList(statesData);
		addMapListeners();
		updateSelectedState(statesData, selectedState);
		selectedState == "US" &&
			svgStates.forEach((el) => {
				el.classList.add("selected");
			});
		selectedState == "US" &&
			document
				.querySelector("[data-state='" + selectedState + "']")
				.classList.add("selected");
	});

let el = document.querySelector(".states-scroll-wrapper");
let scrollLeftButton = el.querySelector(".scroll-button-left");
let scrollRightButton = el.querySelector(".scroll-button-right");
let container = el.querySelector('[class*="-scroll"]');
let scrollAmount = el.dataset.scrollByAmount
	? el.dataset.scrollByAmount
	: "100";

scrollLeftButton.addEventListener("click", function () {
	container.scrollBy({ top: 0, left: -scrollAmount, behavior: "smooth" });
});
scrollRightButton.addEventListener("click", function () {
	container.scrollBy({ top: 0, left: scrollAmount, behavior: "smooth" });
});
